export const COPY_COLOR = '#e27301';
export const EMAIL_COLOR = '#aee86d';
export const FACEBOOK_COLOR = '#3b5998';
export const TWITTER_COLOR = '#00aced';
